import {Component, OnInit, ViewChild, Input, OnDestroy, Output, EventEmitter} from '@angular/core';
import {CommonsService} from 'src/app/services/common.service';
import {MethodsService} from 'src/app/services/methods.service';
import {InteractionsService} from 'src/app/services/interactions.service';

@Component({
    selector: 'app-trova-errore',
    templateUrl: './trova-errore.component.html',
    styleUrls: ['./trova-errore.component.scss']
})
export class TrovaErroreComponent implements OnInit, OnDestroy {

    @Output() tentativiStatus = new EventEmitter();

    public complete = false;
    public rows: number;
    public columns: number;
    public errors;
    public errorIds;
    public errorIdsFound = 0;
    public errorsFound = 0;
    public image: string;
    public wrongImage: string;
    public items = [];
    public wrongItems = [];
    public randomizedItems = [];
    public imageWidth: number;
    public imageHeight: number;
    public puzzleWrapperWidth: number;
    public interaction;
    private interactionsSubscriber;
    public language;
    public localStorage = localStorage;
    @ViewChild('trovaerrore') trovaerrore;


    @Input('interactionId') interactionId;

    constructor(
        private interactionsService: InteractionsService,
        private methods: MethodsService
    ) {
      this.language = localStorage.getItem('l')
    }

    ngOnInit() {
        this.interactionsSubscriber = this.interactionsService.interactions$.subscribe(interactions => {
            this.items = [];
            this.errorsFound = 0;
            this.interaction = interactions.filter(interaction => interaction.id === this.interactionId)[0];

            this.methods.get('assets/data/' +this.language +'/' + this.interaction.content.configId + '.config.json').subscribe(config => {
                this.rows = config.rows;
                this.columns = config.columns;
                this.image = config.image;
                this.interaction.tentativiRimanenti = config.tentativiMax;
                this.interaction.tentativiMax = config.tentativiMax;
                this.wrongImage = config.wrongImage;
                this.imageWidth = config.imageWidth;
                this.imageHeight = config.imageHeight;
                this.errors = config.errors;
                this.puzzleWrapperWidth = this.trovaerrore.nativeElement.offsetWidth;
                this.getTheGrid();
                this.wrongItems = this.items.map(a => ({...a})); // duplicate an array of objects
                this.errorIds = this.getErrorIds(this.errors);
            });

        });

        // ON CHANGE ORIENTATION RELOAD ITEMS
        window.addEventListener('orientationchange', (event: any) => {
            this.puzzleWrapperWidth = screen.width - 30;
            this.getTheGrid();
        });


    }

    getTheGrid() {
        this.items = [];
        let row = 0;
        let col = 0;
        for (let i = 0; i < this.rows * this.columns; i++) {
            let errors = false;
            let errorId = null;
            this.errors.forEach(error => {
                if (error.row === row && error.col === col) {
                    errors = true;
                    errorId = error.id;
                }
            });
            const width = this.puzzleWrapperWidth / this.columns;
            const height = ((this.puzzleWrapperWidth * this.imageHeight) / this.imageWidth) / this.rows;
            this.items.push({
                id: i,
                width: width,
                height: height,
                backgroundPosition: (col * width) * -1 + 'px ' + (row * height) * -1 + 'px',
                opacity: 1,
                errors: errors,
                errorId: errorId
            });
            if (col < this.columns - 1) {
                col++;
            } else {
                col = 0;
                row++;
            }
        }
    }

    isWrong(item) {
      console.log(item)
        if (!this.interaction.completed.onComplete) {
            if (item.errors) {
                this.tentativiStatus.emit('green');
                this.errorIds = this.errorIds.filter(error => error.id !== item.errorId);
                this.errorIdsFound++;
                const items = this.wrongItems.filter(wrongItem => wrongItem.errorId === item.errorId);
                this.errorsFound += items.length;
                items.forEach(wrongItem => {
                    wrongItem.opacity = 0;
                });
                if (this.errorsFound === this.errors.length) {
                    this.interaction.completed = {
                        onComplete: true,
                        status: 'success'
                    };
                    this.interactionsService.setCompleted(this.interaction);
                    this.interactionsService.updateInteraction(this.interaction);
                }
            } else {
                this.tentativiStatus.emit('red');
                this.interaction.tentativiRimanenti--;
                if (this.interaction.tentativiRimanenti <= 0) {
                    this.interaction.completed = {
                        onComplete: true,
                        status: 'failed'
                    };
                    this.interactionsService.setCompleted(this.interaction);
                    this.interactionsService.updateInteraction(this.interaction);
                    // When updateInteraction runs, a new updated subject is pushed to the subscriber,
                    // So the subscription in this ngOnInit runs again.
                    // tslint:disable-next-line: max-line-length
                    this.interaction.tentativiRimanenti = 0; // This is to display error. Once user click on Reset, tentativi is not null and so it will be egual to tentativiMax.
                }
            }
        }
    }

    getErrorIds(errors) {
        const errorArray = [];
        errors.forEach(error => {
            if (!errorArray.includes(error.id)) {
                errorArray.push(error.id);
            }
        });
        return errorArray;
    }

    ngOnDestroy() {
        this.interactionsSubscriber.unsubscribe();
    }

}
